const langPrefix = '/fr'
export default {
  menu: {
    work: {
      link: {
        en: '/work',
        fr: langPrefix + '/projets'
      },
      label: {
        en: 'Work',
        fr: 'Projets'
      }
    },
    contact: {
      link: {
        en: '/contact',
        fr: langPrefix + '/contact'
      },
      label: {
        en: 'Contact',
        fr: 'Contact'
      }
    },
    expertise: {
      link: {
        en: 'expertise',
        fr: langPrefix + '/expertise'
      },
      label: {
        en: 'Expertise',
        fr: 'Expertise'
      }
    }
  },
  homepage: {
    featured: {
      title: {
        en: 'Featured projects',
        fr: 'Projets'
      }
    },
    seeAll: {
      label: {
        en: 'See all projects',
        fr: 'Voir tous les projets'
      },
      link: {
        en: '/work',
        fr: '/fr/projets'
      }
    }
  },
  footer: {
    connect: {
      en: 'Connect',
      fr: 'Contact'
    },
    city: {
      en: 'Montreal',
      fr: 'Montréal'
    },
    tel: '1 514 909 9063',
    email: 'info@littlebox.io',
    inquiries: {
      title: {
        en: 'New Business Enquiries',
        fr: 'Opportunités de collaboration'
      },
      text: {
        en: 'If you think we might be a good match for your business or you just want to discuss the state for the world and rise of automation, please <a href="https://littlebox.io/contact">contact us</a>.',
        fr: 'Si vous croyez que nous pourrions être une bonne solution pour votre entreprise ou si vous souhaitez simplement discuter de l\'état du monde et de l\'essor de l\'automatisation, veuillez <a href=\'https://littlebox.io/fr/contact\'>nous contacter</a>.'
      }
    }
  },
  nav: {
    next: {
      en: 'Next',
      fr: 'Suivant'
    },
    prev: {
      en: 'Prev',
      fr: 'Précédent'
    }
  },
  expertise: {
    whatWeLookLike: {
      en: 'What We Look Like',
      fr: 'À quoi nous ressemblons'
    }
  },
  contact: {
    en: 'Contact us',
    fr: 'Contactez-nous'
  },
  project: {
    allProjects: {
      en: 'All Projects',
      fr: 'Tous les projets'
    },
    ourRole: {
      en: 'LittleBox\'s Role',
      fr: 'Le rôle de LittleBox'
    },
    technologies: {
      en: 'Technologies',
      fr: 'Technologies'
    },
    client: {
      en: 'Client',
      fr: 'Client'
    },
    project: {
      en: 'Project',
      fr: 'Projet'
    },
    year: {
      en: 'Year',
      fr: 'Année'
    },
    role: {
      en: 'Role',
      fr: 'Rôle'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/translations.js